
    
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
    import {useRouter, useRoute} from "vue-router";
    import {useStore} from "@/store";

    interface State {
        channelType: string;
        reportLevel: number;
        ecuInfo: object;
    }
    export default defineComponent({
        name: "EcuCheck",
        setup() {
            let state: State = reactive({
                channelType: '',
                reportLevel: 0,
                ecuInfo: {},
            })
            let store = useStore()
            // 获取路由器实例
            const router = useRouter()
            const {query} = useRoute();
            state.channelType = `${query.channelType}` || '';
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {ecuInfo} = data;
                state.ecuInfo = ecuInfo || {};
            })
            return {
                state,
                router
            }
        },
        methods: {
            toView(){
                this.router.push({
                    path: '/ecu'
                })
            }
        }
    })
